import { dataAiBubbleSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAiBubbleSolid = /*#__PURE__*/createIcon(dataAiBubbleSolid)
export default IconAiBubbleSolid
